import AppStorage from './appStorage';
import RequestsStorage from './requestsStorage';

export default AppStorage;
export {
  AppStorage,
  RequestsStorage,
};
